/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchTrackableAssetsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type FetchTrackableAssetsQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, status?: Types.AssetStatus | null } | null> | null };

export type FetchBagsForBaleCreateQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type FetchBagsForBaleCreateQuery = { __typename?: 'Query', trackableAssets_aggregate?: { __typename?: 'AggregationResult', count: number } | null };

export type LinkPhotoToBaleMutationVariables = Types.Exact<{
  input: Types.ScanEventPhotoInsertInput;
}>;


export type LinkPhotoToBaleMutation = { __typename?: 'Mutation', createScanEventPhoto?: { __typename?: 'ScanEventPhoto', id: string } | null };

export type FacilityBaleCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FacilityBaleCreateInput>;
}>;


export type FacilityBaleCreateMutation = { __typename?: 'Mutation', facilityBaleCreate?: { __typename?: 'ScanEvent', id: string } | null };


export const FetchTrackableAssetsDocument = gql`
    query FetchTrackableAssets($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    status
  }
}
    `;

/**
 * __useFetchTrackableAssetsQuery__
 *
 * To run a query within a React component, call `useFetchTrackableAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTrackableAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTrackableAssetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTrackableAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>(FetchTrackableAssetsDocument, options);
      }
export function useFetchTrackableAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>(FetchTrackableAssetsDocument, options);
        }
export function useFetchTrackableAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>(FetchTrackableAssetsDocument, options);
        }
export type FetchTrackableAssetsQueryHookResult = ReturnType<typeof useFetchTrackableAssetsQuery>;
export type FetchTrackableAssetsLazyQueryHookResult = ReturnType<typeof useFetchTrackableAssetsLazyQuery>;
export type FetchTrackableAssetsSuspenseQueryHookResult = ReturnType<typeof useFetchTrackableAssetsSuspenseQuery>;
export type FetchTrackableAssetsQueryResult = Apollo.QueryResult<FetchTrackableAssetsQuery, FetchTrackableAssetsQueryVariables>;
export const FetchBagsForBaleCreateDocument = gql`
    query FetchBagsForBaleCreate($filter: TrackableAssetsListFilter) {
  trackableAssets_aggregate(filter: $filter) {
    count
  }
}
    `;

/**
 * __useFetchBagsForBaleCreateQuery__
 *
 * To run a query within a React component, call `useFetchBagsForBaleCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBagsForBaleCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBagsForBaleCreateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchBagsForBaleCreateQuery(baseOptions?: Apollo.QueryHookOptions<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>(FetchBagsForBaleCreateDocument, options);
      }
export function useFetchBagsForBaleCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>(FetchBagsForBaleCreateDocument, options);
        }
export function useFetchBagsForBaleCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>(FetchBagsForBaleCreateDocument, options);
        }
export type FetchBagsForBaleCreateQueryHookResult = ReturnType<typeof useFetchBagsForBaleCreateQuery>;
export type FetchBagsForBaleCreateLazyQueryHookResult = ReturnType<typeof useFetchBagsForBaleCreateLazyQuery>;
export type FetchBagsForBaleCreateSuspenseQueryHookResult = ReturnType<typeof useFetchBagsForBaleCreateSuspenseQuery>;
export type FetchBagsForBaleCreateQueryResult = Apollo.QueryResult<FetchBagsForBaleCreateQuery, FetchBagsForBaleCreateQueryVariables>;
export const LinkPhotoToBaleDocument = gql`
    mutation LinkPhotoToBale($input: ScanEventPhotoInsertInput!) {
  createScanEventPhoto(input: $input) {
    id
  }
}
    `;
export type LinkPhotoToBaleMutationFn = Apollo.MutationFunction<LinkPhotoToBaleMutation, LinkPhotoToBaleMutationVariables>;

/**
 * __useLinkPhotoToBaleMutation__
 *
 * To run a mutation, you first call `useLinkPhotoToBaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPhotoToBaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPhotoToBaleMutation, { data, loading, error }] = useLinkPhotoToBaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkPhotoToBaleMutation(baseOptions?: Apollo.MutationHookOptions<LinkPhotoToBaleMutation, LinkPhotoToBaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkPhotoToBaleMutation, LinkPhotoToBaleMutationVariables>(LinkPhotoToBaleDocument, options);
      }
export type LinkPhotoToBaleMutationHookResult = ReturnType<typeof useLinkPhotoToBaleMutation>;
export type LinkPhotoToBaleMutationResult = Apollo.MutationResult<LinkPhotoToBaleMutation>;
export type LinkPhotoToBaleMutationOptions = Apollo.BaseMutationOptions<LinkPhotoToBaleMutation, LinkPhotoToBaleMutationVariables>;
export const FacilityBaleCreateDocument = gql`
    mutation FacilityBaleCreate($input: FacilityBaleCreateInput) {
  facilityBaleCreate(input: $input) {
    id
  }
}
    `;
export type FacilityBaleCreateMutationFn = Apollo.MutationFunction<FacilityBaleCreateMutation, FacilityBaleCreateMutationVariables>;

/**
 * __useFacilityBaleCreateMutation__
 *
 * To run a mutation, you first call `useFacilityBaleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacilityBaleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facilityBaleCreateMutation, { data, loading, error }] = useFacilityBaleCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFacilityBaleCreateMutation(baseOptions?: Apollo.MutationHookOptions<FacilityBaleCreateMutation, FacilityBaleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FacilityBaleCreateMutation, FacilityBaleCreateMutationVariables>(FacilityBaleCreateDocument, options);
      }
export type FacilityBaleCreateMutationHookResult = ReturnType<typeof useFacilityBaleCreateMutation>;
export type FacilityBaleCreateMutationResult = Apollo.MutationResult<FacilityBaleCreateMutation>;
export type FacilityBaleCreateMutationOptions = Apollo.BaseMutationOptions<FacilityBaleCreateMutation, FacilityBaleCreateMutationVariables>;